import type { FastifyInstance } from 'fastify'
import type { GamificationController } from './gamification.controller'
import type { SeasonController } from './season.controller'
import { authMiddleware } from '../../middleware/auth.middleware'

export async function gamificationRoutes(
  app: FastifyInstance,
  controller: GamificationController,
  seasonController?: SeasonController
) {
  // Apply auth to all routes
  app.addHook('onRequest', authMiddleware)

  // Profile & Stats
  app.get('/profile', {
    handler: controller.getProfile.bind(controller)
  })

  app.get('/leaderboard', {
    handler: controller.getLeaderboard.bind(controller)
  })

  app.get('/achievements', {
    handler: controller.getAchievements.bind(controller)
  })

  app.post('/badges/:badgeId/claim', {
    handler: controller.claimBadge.bind(controller)
  })

  // Fuel endpoints
  app.get('/fuel', {
    handler: controller.getFuel.bind(controller)
  })

  app.post('/fuel/spend', {
    handler: controller.spendFuel.bind(controller)
  })

  app.post('/fuel/regenerate', {
    handler: controller.regenerateFuel.bind(controller)
  })

  // Quest endpoints
  app.get('/quests', {
    handler: controller.getQuests.bind(controller)
  })

  app.get('/quests/active', {
    handler: controller.getActiveQuests.bind(controller)
  })

  app.post('/quests/daily/generate', {
    handler: controller.generateDailyQuests.bind(controller)
  })

  app.post('/quests/weekly/generate', {
    handler: controller.generateWeeklyQuest.bind(controller)
  })

  app.post('/quests/track', {
    handler: controller.trackObjectiveProgress.bind(controller)
  })

  app.post('/quests/:questId/complete', {
    handler: controller.completeQuest.bind(controller)
  })

  // Challenge endpoints
  app.get('/challenges', {
    handler: controller.getChallenges.bind(controller)
  })

  app.get('/challenges/season', {
    handler: controller.getSeasonChallenges.bind(controller)
  })

  app.post('/challenges/season/generate', {
    handler: controller.generateSeasonChallenges.bind(controller)
  })

  app.post('/challenges/:challengeId/progress', {
    handler: controller.updateChallengeProgress.bind(controller)
  })

  app.post('/challenges/ai/generate', {
    handler: controller.generateAIChallengeIdea.bind(controller)
  })

  // Season endpoints
  if (seasonController) {
    app.get('/season', {
      handler: seasonController.getSeasonProgress.bind(seasonController)
    })

    app.get('/season/rewards/unclaimed', {
      handler: seasonController.getUnclaimedRewards.bind(seasonController)
    })

    app.post('/season/rewards/claim', {
      handler: seasonController.claimReward.bind(seasonController)
    })

    app.get('/season/van-actions', {
      handler: seasonController.getVanActions.bind(seasonController)
    })

    app.post('/season/van-action', {
      handler: seasonController.performVanAction.bind(seasonController)
    })

    app.get('/season/leaderboard', {
      handler: seasonController.getSeasonLeaderboard.bind(seasonController)
    })
  }
}
